import { Injectable } from '@angular/core';

@Injectable()
export class NotificationData {
  public title: string;
  public message?: string;
  public messageHTML?: string;
  public actionButtonLabel?: string;
  public topButtonLabel?: string;
}
